import { render, staticRenderFns } from "./BmEcommerce.vue?vue&type=template&id=6276cd7d&"
import script from "./BmEcommerce.vue?vue&type=script&lang=js&"
export * from "./BmEcommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports